import { IoIosArrowBack, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useEffect } from "react";
import DialModal from "../RequestSentDetails/DialModal";
import SendEmail from "../RequestSentDetails/EmailModel/Sendemail";
import CallRecordingPlayerModal from "../RequestSentDetails/RecordPlayerModal";
import "./AgencyDetailPage.css";
import ".././RequestSentDetails/AgenctTicketHistory/ticketDetails.css";
import { MdCancel } from "react-icons/md";
import { BsTelephoneInbound, BsTelephoneOutbound } from "react-icons/bs";
import ChequesModal, { ChequePreviewModal, ChequesSectionContent } from "./ChequesModal";
import NotesModal, { NotesSectionContent } from "./NotesModal";
import RequestsModal, { RequestsSectionContent } from "./RequestsModal";
import EventsModal, { TableSectionContent } from "./EventsModal";
import CallHistoryModal, { CallAnalysisModal, CallHistorySectionContent } from "./CallHistoryModal";
import MailHistoryModal, { MailHistorySectionContent, MailHistoryViewSwitch, MailOpenModal } from "./MailHistoryModal";
import { DEFAULT_VISIBLE_COUNT, useAgencyDetailPageLogic } from "./AgencyDetailPageLogic";

const AgencyDetailPage = () => {
  // console.log("AgencyDetailPage component rendered");

  const {
    navigate,
    searchItem,
    datasetID,
    datasetName,
    hasSearched,
    agencySections,
    openSections,
    activeSectionModal,
    mailViewMode,
    setMailViewMode,
    callHistoryIncoming,
    setCallHistoryIncoming,
    selectedActionRequest,
    dialOpen,
    setDialOpen,
    showMailModal,
    setShowMailModal,
    showViewChequeModal,
    chequePdfUrl,
    viewChequeRequestId,
    analysisCall,
    setAnalysisCall,
    modalOpen,
    setModalOpen,
    modalItem,
    audioUrl,
    setAudioUrl,
    playingId,
    setPlayingId,
    isPlaying,
    setIsPlaying,
    audioRef,
    selectedMail,
    setSelectedMail,
    showMailHeaderDetails,
    setShowMailHeaderDetails,
    mailHeaderToggleRef,
    mailHeaderDetailsRef,
    addModalType,
    addNoteText,
    setAddNoteText,
    addEventData,
    setAddEventData,
    addActionErrors,
    addChequeData,
    setAddChequeData,
    getSenderDisplayName,
    getSenderInitial,
    formatMailDateTime,
    fetchAgencyDetails,
    toggleSection,
    openSectionModal,
    closeSectionModal,
    getNoteKey,
    isNotePinned,
    clearAddActionError,
    getCurrentDateTimeInputValue,
    closeAddActionModal,
    openAddActionModal,
    handleAddNoteSubmit,
    handleAddEventSubmit,
    handleAddChequeSubmit,
    handleViewCheque,
    closeViewChequeModal,
    handlePlay,
    closeAnalysisModal,
  } = useAgencyDetailPageLogic();

  const renderMailHistoryViewSwitch = (className = "") => (
    <MailHistoryViewSwitch
      className={className}
      mailViewMode={mailViewMode}
      setMailViewMode={setMailViewMode}
    />
  );
  const mailHistoryModalViewSwitch = renderMailHistoryViewSwitch("adp-mail-history-modal-toggle");
  console.log("searchItem:", searchItem);


  const renderSectionContent = (section, records) => {
    if (section.id === "callHistory") {
      return (
        <CallHistorySectionContent
          records={records}
          audioRef={audioRef}
          setIsPlaying={setIsPlaying}
          setPlayingId={setPlayingId}
          callHistoryIncoming={callHistoryIncoming}
          handlePlay={handlePlay}
          playingId={playingId}
          isPlaying={isPlaying}
          setAnalysisCall={setAnalysisCall}
          analysisCall={analysisCall}
        />
      );
    }

    if (records.length === 0) {
      return <div className="adp-empty-text">No {section.title.toLowerCase()} found.</div>;
    }

    if (section.id === "cheques") {
      return <ChequesSectionContent section={section} records={records} handleViewCheque={handleViewCheque} />;
    }
    if (section.id === "notes") {
      return <NotesSectionContent records={records} getNoteKey={getNoteKey} isNotePinned={isNotePinned} />;
    }
    if (section.id === "requests") {
      return <RequestsSectionContent records={records} />;
    }
    if (section.id === "mailHistory") {
      return (
        <MailHistorySectionContent
          records={records}
          mailViewMode={mailViewMode}
          setSelectedMail={setSelectedMail}
          datasetID={datasetID}
          datasetName={datasetName}
        />
      );
    }

    return <TableSectionContent section={section} records={records} />;
  };
  const getSectionRecords = (section) => {
    if (section?.id === "notes") {
      return [...(section.records || [])].sort((a, b) => Number(isNotePinned(b)) - Number(isNotePinned(a)));
    }

    if (section?.id === "callHistory") {
      return (section.records || []).filter((record) => record.incoming === callHistoryIncoming);
    }

    return section?.records || [];
  };

  const activeSection = agencySections.find((section) => section.id === activeSectionModal);
  const activeSectionRecords = getSectionRecords(activeSection);
  const callHistoryTitle = `Call History ${callHistoryIncoming ? " - Incoming" : " - Outgoing"} `;
  const callHistoryDirectionSwitch = (
    <div
      className="call-history-direction-switch"
      role="group"
      aria-label="Call direction"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <button
        className={`call-history-direction-option ${callHistoryIncoming ? "active inbound" : ""}`}
        type="button"
        onClick={() => setCallHistoryIncoming(true)}
        title="Incoming Calls"
      >
        <BsTelephoneInbound />
        <span>Incoming</span>
      </button>
      <button
        className={`call-history-direction-option ${!callHistoryIncoming ? "active outbound" : ""}`}
        type="button"
        onClick={() => setCallHistoryIncoming(false)}
        title="Outgoing Calls"
      >
        <BsTelephoneOutbound />
        <span>Outgoing</span>
      </button>
    </div>
  );
  const getRequestType = (agency = {}) =>
    agency.requestMethod?.requestType ||
    agency.requestType ||
    agency.request_method?.requestType ||
    "NA";
  const mailHistoryForModal = agencySections
    .find((section) => section.id === "mailHistory")
    ?.records?.map((record) => record.raw) || [];
  const toEmailsForModal = Array.isArray(selectedActionRequest?.requestMethod?.emailSettings)
    ? selectedActionRequest.requestMethod.emailSettings
    : [];
  const headerRequestRecord = agencySections.find((section) => section.id === "requests")?.records?.[0] || {};

  const headerDatasetID = searchItem.datasetID;

  const headerDatasetName = searchItem.datasetName;

  const headerAgencyID = searchItem.agencyID;

  const headerAgencyName = searchItem.agencyName;

  const headerRequestType = getRequestType(searchItem);

  const headerResponseType = searchItem.responseMethod?.responseType;

  // console.log("DETAIL PAGE ROUTE AGENCY:", routeAgency);

  // console.log(
  //   "PHONE DIRECT:",
  //   routeAgency.agencyPhoneNumber
  // );

  // console.log(
  //   "PHONE ARRAY:",
  //   routeAgency.agencyPhoneNumbers
  // );

  const headerPrimaryPhoneNumber =
    searchItem.agencyPhoneNumber ||
    searchItem.agencyPhoneNumbers?.find(
      (item) => item.isPrimary
    )?.number ||
    searchItem.agencyPhoneNumbers?.[0]?.number ||
    "NA";

  const formatHeaderValue = (id, name) => {
    if (id && name && id !== name) return `${id} - ${name}`;
    return id || name || "NA";
  };
  const formatHeaderTextValue = (value) => value || "NA";

  // Page UI
  return (
    <>
      <div className="adp-page-shell">
        <div className="adp-screen-heading"><button
          type="button"
          className="back-btn-details"
          onClick={() => {
            navigate("/Agencies");
          }}
        > <IoIosArrowBack />
          Back
        </button>
          <span>Agency Details</span>
          <div className="adp-agency-context-header">
            <div className="adp-agency-context-row adp-agency-context-row-main">
              <div className="adp-agency-context-item">

                <span className="adp-agency-context-label">
                  Dataset :
                </span>

                <span className="adp-agency-context-value">
                  {formatHeaderValue(headerDatasetID, headerDatasetName)}
                </span>
              </div>
              <div className="adp-agency-context-item">

                <span className="adp-agency-context-label">
                  Agency :
                </span>

                <span className="adp-agency-context-value">
                  {formatHeaderValue(headerAgencyID, headerAgencyName)}
                </span>
              </div>
            </div>
            <div className="adp-agency-context-row adp-agency-context-row-details">
              <div className="adp-agency-context-item">
                <span className="adp-agency-context-label">
                  Request Type :
                </span>
                <span className="adp-agency-context-value">
                  {formatHeaderTextValue(headerRequestType)}
                </span>
              </div>
              <div className="adp-agency-context-item">
                <span className="adp-agency-context-label">
                  Response Type :
                </span>
                <span className="adp-agency-context-value">
                  {formatHeaderTextValue(headerResponseType)}
                </span>
              </div>
              <div className="adp-agency-context-item">
                <span className="adp-agency-context-label">
                  PH :
                </span>
                <span className="adp-agency-context-value">
                  {formatHeaderTextValue(headerPrimaryPhoneNumber)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <form className="adp-filter-panel" onSubmit={handleSearch}>
          <div className="adp-control-group">
            <label htmlFor="adp-dataset">Dataset</label>
            <div
              className="adp-search-select"
              onBlur={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setIsDatasetDropdownOpen(false);
                }
              }}
            >
              <input
                id="adp-dataset"
                type="text"
                value={datasetSearch}
                onChange={handleDatasetSearchChange}
                onFocus={() => setIsDatasetDropdownOpen(true)}
                onKeyDown={handleDatasetKeyDown}
                placeholder="Select Dataset"
                autoComplete="off"
              />
              <button
                className="adp-search-select-toggle"
                type="button"
                onClick={() => setIsDatasetDropdownOpen((previous) => !previous)}
                aria-label="Toggle dataset options"
              >
                <FiChevronDown />
              </button>
              {isDatasetDropdownOpen && (
                <div className="adp-search-select-menu">
                  {filteredDatasets.length > 0 ? filteredDatasets.map((dataset) => (
                    <button
                      className={`adp-search-select-option ${datasetID === dataset.datasetID ? "selected" : ""}`}
                      key={dataset._id || dataset.id || dataset.datasetID}
                      type="button"
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => selectDataset(dataset)}
                    >
                      {getDatasetLabel(dataset)}
                    </button>
                  )) : (
                    <div className="adp-search-select-empty">No datasets found</div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="adp-control-group">
            <label htmlFor="adp-agency">Agency</label>
            <div
              className={`adp-search-select ${!datasetID ? "disabled" : ""}`}
              onBlur={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setIsAgencyDropdownOpen(false);
                }
              }}
            >
              <input
                id="adp-agency"
                type="text"
                value={agencySearch}
                onChange={handleAgencySearchChange}
                onFocus={() => datasetID && setIsAgencyDropdownOpen(true)}
                onKeyDown={handleAgencyKeyDown}
                placeholder="Select Agency"
                autoComplete="off"
                disabled={!datasetID}
              />
              <button
                className="adp-search-select-toggle"
                type="button"
                onClick={() => datasetID && setIsAgencyDropdownOpen((previous) => !previous)}
                aria-label="Toggle agency options"
                disabled={!datasetID}
              >
                <FiChevronDown />
              </button>
              {isAgencyDropdownOpen && (
                <div className="adp-search-select-menu">
                  {filteredAgencyOptions.length > 0 ? filteredAgencyOptions.map((agency) => (
                    <button
                      className={`adp-search-select-option ${agencyID === agency.agencyID ? "selected" : ""}`}
                      key={agency._id || agency.id || agency.agencyID}
                      type="button"
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => selectAgency(agency)}
                    >
                      {getAgencyLabel(agency)}
                    </button>
                  )) : (
                    <div className="adp-search-select-empty">No agencies found</div>
                  )}
                </div>
              )}
            </div>
          </div>

          <button className="adp-submit-btn" type="submit">
            <FiSearch /> Search
          </button>
        </form> */}

        <div className="adp-accordion-panel">
          {!hasSearched ? (
            <div className="adp-empty-screen-text">No records found. Please select Dataset, then click Search.</div>
          ) : agencySections.map((section) => {
            const isOpen = openSections.includes(section.id);
            const sectionRecords = getSectionRecords(section);
            const visibleRecords = sectionRecords.slice(0, DEFAULT_VISIBLE_COUNT);
            const sectionTitle = section.id === "callHistory" ? callHistoryTitle : section.title;
            const showViewAll = section.id === "callHistory"
              ? (section.records || []).length >= DEFAULT_VISIBLE_COUNT
              : sectionRecords.length >= DEFAULT_VISIBLE_COUNT;

            return (
              <div className="adp-accordion-item" key={section.id}>
                <div
                  className="adp-accordion-header"
                  onClick={() => toggleSection(section.id)}
                  role="button"
                  tabIndex={0}
                  aria-expanded={isOpen}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      toggleSection(section.id);
                    }
                  }}
                >
                  <span>{sectionTitle}</span>

                  <span className="adp-header-actions">
                    {section.id === "callHistory" && callHistoryDirectionSwitch}
                    {section.id === "mailHistory" && renderMailHistoryViewSwitch()}
                    {["cheques", "notes", "events"].includes(section.id) && (
                      <button
                        className="adp-header-add-btn"
                        type="button"
                        onClick={(event) => openAddActionModal(section.id, event)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            openAddActionModal(section.id, event);
                          }
                        }}
                      >
                        + Add {section.id === "cheques" ? "Cheque" : section.id === "notes" ? "Note" : "Event"}
                      </button>
                    )}
                    {showViewAll && (
                      <button
                        className="adp-header-view-all"
                        type="button"
                        onClick={(event) => openSectionModal(section.id, event)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            openSectionModal(section.id, event);
                          }
                        }}
                      >
                        View All
                      </button>
                    )}
                    {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                  </span>
                </div>

                {isOpen && (
                  <div className="adp-accordion-body">
                    {renderSectionContent(section, visibleRecords)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {showMailModal && (
        <SendEmail
          vin={selectedActionRequest?.requestID || ""}
          datasetID={datasetID}
          datasetName={datasetName}
          agencyName={headerAgencyName}
          fromEmail={selectedActionRequest?.responseMethod?.emailSettings?.[0] || ""}
          toEmails={toEmailsForModal}
          onClose={() => setShowMailModal(false)}
          waitDays={0}
          mailHistory={mailHistoryForModal}
          refreshMailHistory={fetchAgencyDetails}
        />
      )}

      <DialModal
        isOpen={dialOpen}
        onClose={() => setDialOpen(false)}
        requestID={selectedActionRequest?.requestID || ""}
        agencyPhoneNumber={selectedActionRequest?.agencyPhoneNumber || ""}
        fetchHistory={fetchAgencyDetails}
        refresh={fetchAgencyDetails}
      />

      {addModalType && (
        <div className="adp-add-action-overlay" >
          <div className="adp-add-action-modal" >
            <div className="adp-add-action-header">
              <span>
                Add {addModalType === "cheques" ? "Cheque" : addModalType === "notes" ? "Note" : "Event"}
              </span>
              <button type="button" className="adp-add-action-close" onClick={closeAddActionModal}>
                <MdCancel size={30} />
              </button>
            </div>

            <form
              className="adp-add-action-body"
              onSubmit={addModalType === "cheques" ? handleAddChequeSubmit : addModalType === "notes" ? handleAddNoteSubmit : handleAddEventSubmit}
              noValidate
            >

              {addModalType === "notes" && (
                <label>
                  Note
                  <textarea
                    rows={4}
                    value={addNoteText}
                    onChange={(event) => {
                      setAddNoteText(event.target.value);
                      clearAddActionError("note");
                    }}
                    placeholder="Enter note"
                    className={addActionErrors.note ? "adp-add-action-invalid" : ""}
                  />
                  {addActionErrors.note && <span className="adp-add-action-error">{addActionErrors.note}</span>}
                </label>
              )}

              {addModalType === "events" && (
                <>
                  <label>
                    Start Date Time
                    <input
                      type="datetime-local"
                      value={addEventData.startDateTime}
                      min={getCurrentDateTimeInputValue()}
                      onChange={(event) => {
                        setAddEventData((previous) => ({ ...previous, startDateTime: event.target.value }));
                        clearAddActionError("startDateTime");
                        clearAddActionError("endDateTime");
                      }}
                      className={addActionErrors.startDateTime ? "adp-add-action-invalid" : ""}
                    />
                    {addActionErrors.startDateTime && <span className="adp-add-action-error">{addActionErrors.startDateTime}</span>}
                  </label>
                  <label>
                    End Date Time
                    <input
                      type="datetime-local"
                      value={addEventData.endDateTime}
                      min={addEventData.startDateTime || getCurrentDateTimeInputValue()}
                      onChange={(event) => {
                        setAddEventData((previous) => ({ ...previous, endDateTime: event.target.value }));
                        clearAddActionError("endDateTime");
                      }}
                      className={addActionErrors.endDateTime ? "adp-add-action-invalid" : ""}
                    />
                    {addActionErrors.endDateTime && <span className="adp-add-action-error">{addActionErrors.endDateTime}</span>}
                  </label>
                  <label>
                    Message
                    <input
                      type="text"
                      value={addEventData.message}
                      onChange={(event) => setAddEventData((previous) => ({ ...previous, message: event.target.value }))}
                      placeholder="Enter message"
                    />
                  </label>
                </>
              )}

              {addModalType === "cheques" && (
                <>
                  <div className="adp-add-action-grid">
                    <label>
                      Payable To
                      <input
                        type="text"
                        value={addChequeData.payableTo}
                        onChange={(event) => {
                          setAddChequeData((previous) => ({ ...previous, payableTo: event.target.value }));
                          clearAddActionError("payableTo");
                        }}
                        placeholder="Enter payable to"
                        className={addActionErrors.payableTo ? "adp-add-action-invalid" : ""}
                      />
                      {addActionErrors.payableTo && <span className="adp-add-action-error">{addActionErrors.payableTo}</span>}
                    </label>
                    <label>
                      Amount
                      <input
                        type="text"
                        value={addChequeData.amount}
                        onChange={(event) => {
                          if (/^\d*\.?\d*$/.test(event.target.value)) {
                            setAddChequeData((previous) => ({ ...previous, amount: event.target.value }));
                            clearAddActionError("amount");
                          }
                        }}
                        placeholder="Enter amount"
                        className={addActionErrors.amount ? "adp-add-action-invalid" : ""}
                      />
                      {addActionErrors.amount && <span className="adp-add-action-error">{addActionErrors.amount}</span>}
                    </label>
                  </div>
                  <label>
                    Address
                    <textarea
                      rows={2}
                      value={addChequeData.address}
                      onChange={(event) => {
                        setAddChequeData((previous) => ({ ...previous, address: event.target.value }));
                        clearAddActionError("address");
                      }}
                      placeholder="Enter address"
                      className={addActionErrors.address ? "adp-add-action-invalid" : ""}
                    />
                    {addActionErrors.address && <span className="adp-add-action-error">{addActionErrors.address}</span>}
                  </label>
                  <div className="adp-add-action-grid three">
                    <label>
                      City
                      <input
                        value={addChequeData.city}
                        onChange={(event) => {
                          setAddChequeData((previous) => ({ ...previous, city: event.target.value }));
                          clearAddActionError("city");
                        }}
                        placeholder="City"
                        className={addActionErrors.city ? "adp-add-action-invalid" : ""}
                      />
                      {addActionErrors.city && <span className="adp-add-action-error">{addActionErrors.city}</span>}
                    </label>
                    <label>
                      State
                      <input
                        value={addChequeData.state}
                        onChange={(event) => {
                          setAddChequeData((previous) => ({ ...previous, state: event.target.value }));
                          clearAddActionError("state");
                        }}
                        placeholder="State"
                        className={addActionErrors.state ? "adp-add-action-invalid" : ""}
                      />
                      {addActionErrors.state && <span className="adp-add-action-error">{addActionErrors.state}</span>}
                    </label>
                    <label>
                      Zip
                      <input
                        value={addChequeData.zip}
                        onChange={(event) => {
                          setAddChequeData((previous) => ({ ...previous, zip: event.target.value }));
                          clearAddActionError("zip");
                        }}
                        placeholder="Zip"
                        className={addActionErrors.zip ? "adp-add-action-invalid" : ""}
                      />
                      {addActionErrors.zip && <span className="adp-add-action-error">{addActionErrors.zip}</span>}
                    </label>
                  </div>
                  <label>
                    Memo
                    <textarea
                      rows={3}
                      value={addChequeData.memo}
                      onChange={(event) => setAddChequeData((previous) => ({ ...previous, memo: event.target.value }))}
                      placeholder="Enter memo"
                    />
                  </label>
                </>
              )}

              <div className="adp-add-action-footer">
                <button type="button" className="adp-add-action-secondary" onClick={closeAddActionModal}>
                  Cancel
                </button>
                <button type="submit" className="adp-add-action-primary">
                  {addModalType === "cheques" ? "Generate Cheque" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <ChequesModal isOpen={activeSectionModal === "cheques"} onClose={closeSectionModal}>
        {activeSection?.id === "cheques" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </ChequesModal>

      <NotesModal isOpen={activeSectionModal === "notes"} onClose={closeSectionModal}>
        {activeSection?.id === "notes" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </NotesModal>

      <RequestsModal isOpen={activeSectionModal === "requests"} onClose={closeSectionModal}>
        {activeSection?.id === "requests" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </RequestsModal>

      <EventsModal isOpen={activeSectionModal === "events"} onClose={closeSectionModal}>
        {activeSection?.id === "events" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </EventsModal>

      <CallHistoryModal
        isOpen={activeSectionModal === "callHistory"}
        onClose={closeSectionModal}
        title={callHistoryTitle}
        headerActions={callHistoryDirectionSwitch}
      >
        {activeSection?.id === "callHistory" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </CallHistoryModal>

      <MailHistoryModal
        isOpen={activeSectionModal === "mailHistory"}
        onClose={closeSectionModal}
        headerActions={mailHistoryModalViewSwitch}
      >
        {activeSection?.id === "mailHistory" && renderSectionContent(activeSection, activeSectionRecords, true)}
      </MailHistoryModal>

      <CallRecordingPlayerModal
        isOpen={modalOpen}
        onClose={() => {
          if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = "";
          }

          setIsPlaying(false);
          setPlayingId(null);
          setAudioUrl(null);
          setModalOpen(false);
        }}
        audioRef={audioRef}
        audioUrl={audioUrl}
        callItem={modalItem}
      />

      <ChequePreviewModal
        isOpen={showViewChequeModal}
        chequePdfUrl={chequePdfUrl}
        viewChequeRequestId={viewChequeRequestId}
        onClose={closeViewChequeModal}
      />
      <CallAnalysisModal
        analysisCall={analysisCall}
        closeAnalysisModal={closeAnalysisModal}
        handlePlay={handlePlay}
        playingId={playingId}
        isPlaying={isPlaying}
      />      <MailOpenModal
        selectedMail={selectedMail}
        setSelectedMail={setSelectedMail}
        showMailHeaderDetails={showMailHeaderDetails}
        setShowMailHeaderDetails={setShowMailHeaderDetails}
        mailHeaderToggleRef={mailHeaderToggleRef}
        mailHeaderDetailsRef={mailHeaderDetailsRef}
        getSenderInitial={getSenderInitial}
        getSenderDisplayName={getSenderDisplayName}
        formatMailDateTime={formatMailDateTime}
        datasetID={datasetID}
        datasetName={datasetName}
      />    </>
  );
};

export default AgencyDetailPage;
